/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
 * ----------------------------------------------------------------------------
 * Custom Functions
 * ----------------------------------------------------------------------------
 */

var SDG = SDG || {};

// Adjusted addToCart function from theme.js
SDG.addToCart = function (event) {
  var element = event.target;

  event.preventDefault(); // Prevent form to be submitted

  var addToCartButton = element.querySelector(".ProductForm__AddToCart");
  var currentVariant = element.querySelector(".ProductForm__Variants").dataset
    .initialVariant;

  // First, we switch the status of the button
  addToCartButton.setAttribute("disabled", "disabled");
  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  // Then we add the product in Ajax
  var formElement = element;

  fetch(window.theme.localeRootUrl + "/cart/add.js", {
    body: JSON.stringify(SDG.serialize(formElement)),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    if (response.ok) {
      addToCartButton.removeAttribute("disabled");
      // We simply trigger an event so the mini-cart can re-render
      element.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: currentVariant,
            quantity: parseInt(
              formElement.querySelector('[name="quantity"]').value,
            ),
          },
        }),
      );
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement("span");
        errorMessageElement.className = "ProductForm__Error Alert Alert--error";
        errorMessageElement.innerHTML = content["description"];
        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });

  event.preventDefault();
};

SDG.serialize = function (form) {
  function stringKey(key, value) {
    var beginBracket = key.lastIndexOf("[");

    if (beginBracket === -1) {
      var _hash = {};
      _hash[key] = value;
      return _hash;
    }

    var newKey = key.substr(0, beginBracket);
    var newValue = {};

    newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

    return stringKey(newKey, newValue);
  }

  var hash = {};

  for (var i = 0, len = form.elements.length; i < len; i++) {
    var formElement = form.elements[i];

    if (formElement.name === "" || formElement.disabled) {
      continue;
    }

    if (
      formElement.name &&
      !formElement.disabled &&
      (formElement.checked ||
        /select|textarea/i.test(formElement.nodeName) ||
        /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
          formElement.type,
        ))
    ) {
      var stringKeys = stringKey(formElement.name, formElement.value);
      hash = SDG.formExtend(hash, stringKeys);
    }
  }

  return hash;
};

SDG.formExtend = function () {
  var extended = {};
  var i = 0;

  // Merge the object into the extended object
  var merge = function merge(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        // If property is an object, merge properties
        if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
          extended[prop] = Form.extend(extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  };

  // Loop through each object and conduct a merge
  for (; i < arguments.length; i++) {
    merge(arguments[i]);
  }

  return extended;
};

SDG.adjustProductCarouselBtns = function (carousel) {
  if (!carousel || !carousel.isActive) return;
  var selectedCell = carousel.selectedCell;
  if (selectedCell)
    var $productImage = selectedCell.element.querySelector(
      ".ProductItem__ImageWrapper",
    );
  if (!$productImage) return;

  var $prevBtn = carousel.prevButton.element;

  $prevBtn.style.top =
    $productImage.clientHeight / 2 - $prevBtn.clientHeight / 2 + "px";
  carousel.nextButton.element.style.top = $prevBtn.style.top;
};

/**
 * ----------------------------------------------------------------------------
 * Global Custom
 * ----------------------------------------------------------------------------
 */

document.addEventListener("breakpoint:changed", function (event) {
  SDG.currentBreakpoint = event.detail.currentBreakpoint;
  SDG.previousBreakpoint = event.detail.previousBreakpoint;
});

document.addEventListener("carousel:build", function (event) {
  SDG.adjustProductCarouselBtns(event.detail.carousel);
});

document.addEventListener("carousel:resize", function (event) {
  SDG.adjustProductCarouselBtns(event.detail.carousel);
});

document.addEventListener("DOMContentLoaded", function () {
  var quickAddForms = document.querySelectorAll(".ProductItem .ProductForm");
  quickAddForms.forEach(function (element) {
    element.addEventListener("submit", function (e) {
      SDG.addToCart(e);
    });
  });
});

/**
 * ----------------------------------------------------------------------------
 * Homepage Custom
 * ----------------------------------------------------------------------------
 */

document.addEventListener("featured-collection:ready", function (event) {
  var $collection = event.detail.element;

  var $productQuickAdds = $collection.querySelectorAll(".ProductForm");
  if ($productQuickAdds.length < 1) return;

  $productQuickAdds.forEach((element) => {
    element.addEventListener("submit", function (e) {
      SDG.addToCart(e);
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var $featuredCollections = document.querySelectorAll(
    '[data-section-type="featured-collections"] .ProductList',
  );

  if ($featuredCollections.length < 1) return;
});

/**
 * ----------------------------------------------------------------------------
 * PDP Custom
 * ----------------------------------------------------------------------------
 */

// Listeners for events dispatched from theme.js
document.addEventListener("recommendations:loaded", function (event) {
  var $productRecs = document.getElementById("productRecommendations");
  var $productQuickAdds = $productRecs.querySelectorAll(".ProductForm");
  $productQuickAdds.forEach((element) => {
    element.addEventListener("submit", function (e) {
      SDG.addToCart(e, event.detail);
    });
  });
});

document.addEventListener("recently-viewed:loaded", function (event) {
  var $productsWrap = document.getElementById(
    "shopify-section-recently-viewed-products",
  );
  var $productQuickAdds = $productsWrap.querySelectorAll(".ProductForm");
  $productQuickAdds.forEach((element) => {
    element.addEventListener("submit", function (e) {
      SDG.addToCart(e, event.detail);
    });
  });
});

/**
 * ----------------------------------------------------------------------------
 * PLP Custom
 * ----------------------------------------------------------------------------
 */
SDG.Collection = SDG.Collection || {};
SDG.Collection.paginateLoadMore;

document.addEventListener("DOMContentLoaded", function () {
  var $collectionAjaxinate = document.getElementById("AjaxinateLoop");

  if ($collectionAjaxinate) {
    SDG.Collection.paginateLoadMore = new Ajaxinate({
      method: "click",
      callback: SDG.Collection.removeExtraTouts,
    });
  }

  var $reviewCarousel = document.getElementById("reviewsCarousel");
  if ($reviewCarousel)
    reviewFlickity = new Flickity(
      $reviewCarousel,
      $reviewCarousel.dataset.flickityConfig,
    );
});

document.addEventListener("collection:relaod-start", function () {
  if (SDG.Collection.paginateLoadMore) {
    SDG.Collection.paginateLoadMore.destroy();
  }
});

document.addEventListener("collection:reload-finished", function () {
  var $collectionAjaxinate = document.getElementById("AjaxinateLoop");

  if ($collectionAjaxinate) {
    SDG.Collection.paginateLoadMore = new Ajaxinate({
      method: "click",
      callback: SDG.Collection.removeExtraTouts,
    });
  }
});

var $sortButtons = document.querySelectorAll(".js-sort-button");
$sortButtons.forEach(function ($button) {
  $button.addEventListener("click", function (e) {
    SDG.Collection.updateSortValue(e);
  });
});

SDG.Collection.removeExtraTouts = function () {
  var touts = document.querySelectorAll(
    "#shopify-section-collection-grid-tout",
  );
  touts.forEach(function (tout, index) {
    if (index != 0) {
      tout.parentNode.removeChild(tout);
    }
  });
};

SDG.Collection.updateSortValue = function (e) {
  var $currentSort = document.getElementById("currentSort");
  var optName = e.target.dataset.name;
  $currentSort.innerText = optName;
};

/**
 * ----------------------------------------------------------------------------
 * PLP Landing
 * ----------------------------------------------------------------------------
 */

//document.addEventListener("DOMContentLoaded", function() {
$(window).on("load", function () {
  var $collectionScents = document.getElementById("collectionScents");

  if ($collectionScents) {
    SDG.Collection.scentEls = document.querySelectorAll(".js-scent-carousel");
    SDG.Collection.scentCarousel = [];

    SDG.Collection.scentEls.forEach(function (el) {
      if (el.childNodes.length > 3) {
        var carousel = new Flickity(el, {
          pageDots: false,
          watchCSS: true,
          contain: true,
          dragThreshold: 8,
          groupCells: true,
          cellAlign: "center",
          wrapAround: true,
        });

        SDG.Collection.scentCarousel.push(carousel);
      } else {
        // var carousel = new Flickity(el, {
        //   pageDots: false,
        //   prevNextButtons: false,
        //   draggable: false,
        //   watchCSS: true,
        //   contain: true,
        //   cellAlign: 'left',
        // });
        // SDG.Collection.scentCarousel.push(carousel);
      }
    });
  }
});

/**
 * ----------------------------------------------------------------------------
 * Limit text width on banners
 * ----------------------------------------------------------------------------
 */
function limitBannerText() {
  if (document.querySelector(".PageHeader")) {
    const homepageSlide = document.getElementById("shopify-section-slideshow");
    const headerBanner = document.querySelector(".PageHeader");
    // Limit text width on top banners, not including the homepage slide
    if (!homepageSlide) {
      const sectionHeading = headerBanner.querySelector(
        ".SectionHeader__Heading",
      );
      const sectionTagline = headerBanner.querySelector(
        ".SectionHeader__Tagline",
      );
      const sectionDescription = headerBanner.querySelector(
        ".SectionHeader__Description",
      );

      if (sectionHeading) {
        sectionHeading.classList.add("SectionHeader__custom");
      }

      if (sectionTagline) {
        sectionTagline.classList.add("SectionHeader__custom");
      }

      if (sectionDescription) {
        sectionDescription.classList.add("SectionHeader__custom");
      }
    }
  }
}

function limitHomepage() {
  if (document.getElementById("shopify-section-slideshow")) {
    const homepageSlide = document.getElementById("shopify-section-slideshow");
    const headerBanner = document.querySelector(".PageHeader");
    // Limit TOP homepage hero slide text
    if (homepageSlide) {
      const slideText = homepageSlide.querySelectorAll(".Slideshow__Content");
      for (let i = 0; i < slideText.length; i++) {
        slideText[i].classList.add("SectionHeader__custom");
      }
    }
  }
}

if (
  document.querySelector(".PageHeader") ||
  document.getElementById("shopify-section-slideshow")
) {
  limitBannerText();
  limitHomepage();
}

/**
 * ----------------------------------------------------------------------------
 * CBD Landing Page
 * ----------------------------------------------------------------------------
 */

$(function () {
  let injectCookieMsg = setInterval(function () {
    if ($(".Avada-CookiesBar__MessageInner").length > 0) {
      $(".Avada-CookiesBar__MessageInner span").html(
        `This website uses cookies, pixels, and other tracking technologies to enhance user experience, analyze performance and traffic, and deliver marketing and advertising. Learn more at our <u><a href="https://hempz.com/pages/privacy-policy" target="_blank">Privacy Policy</a></u>. By using this website, you agree to our <u><a href="https://hempz.com/pages/terms-conditions" target="_blank">Terms and Conditions</a></u>.`,
      );
      clearInterval(injectCookieMsg);
    }
  }, 500);

  /*
  if($(".Product__SlideItem--video").length > 0) {
    setInterval(function(){
      if($(".Product__SlideItem--video.is-selected").length > 0) {
          if(!$(".Product__SlideItem--video.is-selected iframe").hasClass("played")) {
          var src = $(".Product__SlideItem--video.is-selected iframe").attr("data-src");
          var attr = $(".Product__SlideItem--video.is-selected iframe").attr("data-attr");
          $(".Product__SlideItem--video.is-selected iframe").attr("src", src+attr);
          $(".Product__SlideItem--video.is-selected iframe").addClass("played");
        }
      }
      $(".Product__SlideItem--video").each(function(){
        if(!$(this).hasClass("is-selected")) {
          var src2 = $(this).children().children("iframe").attr("src");
          $(this).children().children("iframe").attr("src", src2);
          $(this).children().children("iframe").removeClass("played");
        }
      });
    }, 1000);
  }
  */
});

// var gift_product = {
//   product_detail: function(event){

//       var promo = true;
//       var first_gift = [];
//       var last_gift = [];
//       var add_gift =[];
//       var change_gift = [];

//       jQuery.getJSON('/cart.js', function(cart) {

//         // first product
//         jQuery(cart.items).each(function(index, item){
//            jQuery(first_product).each(function(i, pd_item){
//             if(pd_item.pd_id == item.id){
//               promo = false;
//               first_gift.push({g_id:pd_item.gift, limit:pd_item.limt, pd_qty: item.quantity});
//             }
//           });

//         });

//         // add qty for gift
//         if(first_gift.length > 0){
//           // sort by
//           first_gift.sort(function(a, b){
//               var a1= a[1], b1= b[1];
//               if(a1== b1) return 0;
//               return a1> b1? 1: -1;
//           });

//           var arr = first_gift[0]['g_id'];
//           $(first_gift).each(function(index, item){
//             if(index != 0){
//               if(item.g_id == arr){
//                 var qty = item.pd_qty + first_gift[index-1]['pd_qty'];
//                 first_gift[index]['pd_qty']=qty;
//                 first_gift[index]['g_id']=0;
//               }else{
//                 arr = item.g_id;
//               }

//              }
//           });
//         }

//         // last product
//         if(promo){
//             jQuery(cart.items).each(function(index, item){

//              jQuery(last_product).each(function(i, pd_item){

//               if(pd_item.pd_id == item.id){
//                 last_gift.push({g_id:pd_item.gift, limit:pd_item.limt, pd_qty: item.quantity});
//               }
//             });
//           });

//             // add qty for gift
//             if(last_gift.length > 0){
//               // sort by
//               last_gift.sort(function(a, b){
//                   var a1= a[1], b1= b[1];
//                   if(a1== b1) return 0;
//                   return a1> b1? 1: -1;
//               });

//               var arr = last_gift[0]['g_id'];
//               $(last_gift).each(function(index, item){
//                 if(index != 0){
//                   if(item.g_id == arr){
//                     var qty = item.pd_qty + last_gift[index-1]['pd_qty'];
//                     last_gift[index]['pd_qty']=qty;
//                     last_gift[index]['g_id']=0;
//                   }else{
//                     arr = item.g_id;
//                   }

//                  }
//               });
//             }

//         }

//         // check gift

//         if(!promo){

//           jQuery(cart.items).each(function(index, item){

//             if(item.product_type == 'gift'){
//               var update = false;
//               var remove = true;
//               var qty = 0;

//               $(first_gift).each(function(i, gf_item){

//                 if(gf_item.g_id == item.id){
//                   remove = false;
//                   first_gift[i]['g_id']=0;
//                   qty = check_qty(item.quantity, gf_item.pd_qty, gf_item.limit);
//                   if(qty !=0){
//                     qty = item.quantity + qty;
//                     update = true;
//                   }

//                   if(qty > gf_item.limit){
//                     qty = gf_item.limit;
//                   }

//                 }
//               });

//               if(remove){
//                 change_gift.push({gift_id:item.id, qty:0});
//               }else if(update){
//                  change_gift.push({gift_id:item.id, qty:qty});
//               }

//             }
//           });

//           // add gift

//           $(first_gift).each(function(index, item){
//             if(item.g_id != 0 ){
//               var qty = item.pd_qty;
//               if(item.pd_qty > item.limit){
//                 qty = item.limit;
//               }
//               add_gift.push({gift_id:item.g_id, qty:qty});
//             }

//           });

//           // remove zero
//           //remvoe_zero();

//         }else{

//            jQuery(cart.items).each(function(index, item){
//             if(item.product_type == 'gift'){
//               var update = false;
//               var remove = true;
//               var qty = 0;
//               $(last_gift).each(function(i, gf_item){
//                 if(gf_item.g_id == item.id){
//                   remove = false;
//                   last_gift[i]['g_id']=0;
//                   qty = check_qty(item.quantity, gf_item.pd_qty, gf_item.limit);
//                   if(qty !=0){
//                     qty = item.quantity + qty;
//                     update = true;
//                   }

//                   if(qty > gf_item.limit){
//                     qty = gf_item.limit;
//                   }

//                 }
//               });

//               if(remove){
//                 change_gift.push({gift_id:item.id, qty:0});
//               }else if(update){
//                  change_gift.push({gift_id:item.id, qty:qty});
//               }

//             }
//           });

//             // add gift

//           console.log(add_gift);

//           $(last_gift).each(function(index, item){
//             if(item.g_id != 0 ){
//               var qty = item.pd_qty;
//               if(item.pd_qty > item.limit){
//                 qty = item.limit;
//               }
//               add_gift.push({gift_id:item.g_id, qty:qty});
//             }

//           });

//           // cart gift
//           var cart_price = cart.total_price/100;
//           if(cart_amount !=0 && cart_price >= cart_amount){

//             var c_gift = false;
//             jQuery(cart.items).each(function(index, item){
//               if(cart_gift == item.id){
//                 c_gift = true;
//               }
//             });

//             if(c_gift){
//               $(change_gift).each(function(index, item){
//                 if(item.gift_id == cart_gift){
//                    change_gift[index]['gift_id'] = 0;
//                 }
//               });

//              }else{
//                add_gift.push({gift_id:cart_gift, qty:1});
//              }
//           }

//         }

//           // call function
//           if(change_gift.length > 0){

//             $(change_gift).each(function(index, item){
//               if(item.gift_id !=0){
//                 change_value(item.gift_id, item.qty);
//               }
//             });
//           }

//           if(add_gift.length > 0){

//               $(add_gift).each(function(index, item){
//               if(item.gift_id !=0){
//                 add_value(item.gift_id, item.qty);
//               }
//             });
//           }

//          setTimeout(function(){
//         	$('[name="checkout"]').show();
//          },6000);

//       });

//     function remvoe_zero(){

//       var arr_chang = [];
//       $(change_gift).each(function(index, item){
//         if(item.gift_id != 0){
//            arr_chang.push(change_gift[index]);
//         }
//       });
//       change_gift = [];
//       change_gift = jQuery.extend({}, arr_chang);

//       var arr_add = [];
//       $(add_gift).each(function(index, item){
//         if(item.gift_id != 0){
//            arr_chang.push(change_gift[index]);
//         }
//       });
//       add_gift = [];
//       add_gift =jQuery.extend({}, arr_add);

//     }

//     function check_qty(add_qty, gift_qty, limit_qty){

//       if(add_qty == gift_qty && add_qty <=limit_qty){
//          return 0;
//       }else if(add_qty > gift_qty){

//          return gift_qty - add_qty;
//       }else if(add_qty < gift_qty){

//         if(gift_qty > limit_qty){
//           gift_qty = limit_qty;
//         }
//          return gift_qty - add_qty;
//       }else{
//         return 0;
//       }
//     }

//     function done_chang_cart(){
// //       setTimeout(function(){
// //          location.reload();
// //      }, 3600);
//     }

//     function add_custom_gift(position, array_length){
//      // var element = event.target;

//         console.log(add_gift[position]['gift_id']);

//         if(add_gift[position]['gift_id'] != 0 ){
//         var data = 'id='+ add_gift[position]['gift_id']+ '&quantity='+add_gift[position]['qty'];
//          console.log(data);
//           $.ajax({
//             type: 'POST',
//             url: '/cart/add.js',
//             dataType: 'json',
//             data: data,
//             success: function(res){
//               position +=1;
//               if(array_length > position){
//               add_custom_gift(position, array_length);
//               }else{
//                 done_chang_cart();
//               }
//            }
//           });
//         }else{
//              position +=1;
//               if(add_gift.lenght > position){
//               add_custom_gift(position, array_length);
//               }else{
//                 done_chang_cart();
//               }
//         }
//     }

//     function change_custom_gift(position, array_length){
//      // var element = event.target;

//        console.log(change_gift[position]['gift_id']);

//         if(change_gift[position]['gift_id'] != 0 ){

//           $.ajax({
//             type: 'POST',
//             url: '/cart/change.js',
//             dataType: 'json',
//             data: {id:change_gift[position]['gift_id'],quantity:change_gift[position]['qty']},
//             success: function(res){
//               position +=1;
//               console.log(array_length);
//               console.log(position);
//               if(array_length > position){
//               change_custom_gift(position, array_length);
//               }else{
//                 done_chang_cart();
//               }

//            }
//           });
//         }else{
//              position +=1;
//               if(change_gift.lenght > position){
//               change_custom_gift(position, array_length);
//               }else{
//                 done_chang_cart();
//               }

//         }

//     }

//     function done_cart(id){

//      // if(id){

//         var element = event.target;

//               element.dispatchEvent(new CustomEvent('product:added', {
//                   bubbles: true,
//                   detail: {
//                     variant: id,
//                     quantity: 1
//                   }
//                 }));

//      // }

//     }

//     function change_value(id, qty){
//       console.log(id);
//        console.log(qty);

//          $.ajax({
//               type: 'POST',
//               url: '/cart/change.js',
//               dataType: 'json',
//               data: {id:id,quantity:qty},
//               success: function(){

//                 done_chang_cart();

//               }
//            });

//     }

//     function add_value(id, qty){

//        console.log(id);
//        console.log(qty);

//          $.ajax({
//               type: 'POST',
//               url: '/cart/add.js',
//               dataType: 'json',
//               data: {id:id,quantity:qty},
//               success: function(){
//                  done_chang_cart();
//               }

//            });

//     }

//   }
// }

var hampz = {
  product_tab_slider: function () {
    if ($(".procuct_list .product_handle").length > 0) {
      $(".shogun-tabs-body .shogun-tab-content").each(function () {
        var that = $(this);

        that
          .find(".procuct_list")
          .children(".product_handle")
          .each(function () {
            var name = $.trim($(this).html());
            var text = $(this).data("text");
            if (text === undefined || text === null) {
              text = "";
            }
            if (name != null && typeof name !== "undefined")
              create_prouct(name, text, that);
          });
      });
    }

    $el = $(".slider_crousol");
    setTimeout(function () {
      $el.show();
      $el.flickity({
        cellAlign: "center",
        contain: true,
        pageDots: false,
        contain: true,
      });
    }, 6000);

    $("body").on("click", ".shogun-tab-box", function () {
      $el.flickity("deactivate");
      setTimeout(function () {
        $el.flickity("activate");
      }, 100);
    });

    /*
          "prevNextButtons": true,
          "pageDots": false,
          "wrapAround": false,
          "contain": true,
          "cellAlign": "center",
          "watchCSS": true,
          "dragThreshold": 8,
          "groupCells": true,
          "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}  */

    function create_prouct(name, text, that) {
      var html = "";
      $.getJSON("/products/" + name + ".js", function (product) {
        html = '<div class="cover_pd_box">';
        html += '<a class="product_link" href="' + product.url + '"></a>';
        if (product.featured_image)
          html +=
            '<div class="prouct_img"><img src="' +
            product.featured_image +
            '" alt="' +
            product.title +
            '"/></div>';
        html +=
          '<div class="prouct_name">' +
          product.title +
          "</div>" +
          '<div class="price">$' +
          product.price / 100 +
          "</div>";
        if (text != "") {
          html +=
            '<div class="custom-field_offer addon_shogun">' + text + "</div>";
        }
        html += "</div>";

        that.find(".slider_crousol").append(html);
      });
    }
  },
};

var backup_btn = {
  setProduuctUrl: function () {
    var backurl = window.location.pathname;
    backup_btn.setCookie("url", backurl, 1);
  },
  getProduuctUrl: function () {
    var url = backup_btn.getCookie();

    var scroll_id = $("#Huratips-Pagination").offset().top;
    var window_scroll = $(window).scrollTop();

    if (window_scroll == 0) {
      setTimeout(function () {
        backup_btn.getProduuctUrl();
      }, 300);
    }

    show_option();

    if (window_scroll > scroll_id) {
      console.log("scroll");
      var window_height = $(window).height() / 2 + 150;

      scroll_id = scroll_id - window_height;
      $("html, body").animate({ scrollTop: scroll_id }, 100);
    }

    function show_option() {
      setTimeout(function () {
        $("#main").css("opacity", 1);
      }, 2200);
    }
  },
  setCookie: function (key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
    document.cookie = key + "=" + value + ";expires=" + expires.toUTCString();
  },
  getCookie: function (key) {
    var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
    return keyValue ? keyValue[2] : null;
  },
  eraseCookie: function (key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, "-1");
  },
};

$(function () {
  //    gift_product.product_detail();

  hampz.product_tab_slider();

  $("body").on("click", ".check_agree", function (e) {
    if (
      $(this).closest("form").find("input#terms-drawer").prop("checked") ==
      false
    ) {
      e.preventDefault();
      alert("You must accept the terms and condition to continue.");
      //You must accept the terms and condition to continue.
    }
  });

  if ($("#sticky-product-container").length > 0) {
    initStickyProduct();
  }

  setTimeout(function () {
    $("#main").css("opacity", 1);
  }, 2200);

  setTimeout(function () {
    $(".preload").fadeOut();
  }, 400);

  /*
    Was a 300ms setInterval that never stopped: it recalculated three times a
    second for the life of the page, and the clear branch called
    x.clearInterval(), which throws because x is an interval id rather than an
    object. Bound to the events that actually change the height instead.
    settle.flickity matters because slides have different content lengths.
  */
  if ($("body").hasClass("template-index")) {
    resizeSliderHeight();

    $(window).on(
      "load.slideshowHeight resize.slideshowHeight orientationchange.slideshowHeight",
      resizeSliderHeight,
    );

    $("#shopify-section-slideshow .Slideshow__Carousel").on(
      "select.flickity settle.flickity",
      resizeSliderHeight,
    );
  }
});

var productJson;
function initStickyProduct() {
  let stickyHtml = `<div class="sticky-product-wrapper">`;
  let rawJson = $("script[data-product-json]").html();
  productJson = JSON.parse(rawJson);
  let selected_id = productJson.selected_variant_id;
  let product = productJson.product;
  let price = $(".ProductMeta__Price").text();
  let variantsHtml = ``;
  let variantOptions = ``;
  $("select[name='id'] option").each(function () {
    let varId = $(this).attr("value");
    let varPrice = $(this).data("price");
    let varTitle = $(this).data("title");
    variantOptions += `<option value="${varId}" data-price="${varPrice}" data-title="${varTitle}" ${varId == selected_id ? "selected" : null}>${varTitle}</option>`;
  });
  if (variantOptions != "") {
    variantsHtml += `<select class="s-variant-selector">${variantOptions}</select>`;
  }
  let buttonText = $(
    ".Product__Info form.ProductForm .ProductForm__AddToCart",
  ).html();
  let qtyHtml = $(".ProductForm__QuantitySelector").html();
  stickyHtml += `
  <div class="sticky-left">
    <div class="s-product-title">${product.title}</div>
    <div class="s-line-split"></div>
    <div class="s-price" data-la-dn-price>${price}</div>
    <div class="s-line-split"></div>
    <div class="s-variants${variantsHtml == "" ? " no-variants" : ""}">${variantsHtml}</div>
    <div class="s-qty"></div>
  </div>
  <div class="sticky-right${variantsHtml == "" ? " no-margin" : ""}">
    <div class="control-wrapper">
      <div class="ProductForm__QuantitySelector">
      ${qtyHtml}
      </div>
      <button type="button" class="s-ProductForm__AddToCart Button Button--tertiary Button--full" data-action="add-to-cart">
        ${buttonText}
      </button>
    </div>
  </div>
  `;
  $("#sticky-product-container").html(stickyHtml);
}

$(document).on("change", "select.s-variant-selector", function () {
  let ind = $(this)
    .children("option[value='" + $(this).val() + "']")
    .index();
  $(".Popover__ValueList button:eq(" + ind + ")").trigger("click");
  setTimeout(function () {
    $(".sticky-product-wrapper .s-ProductForm__AddToCart").html(
      $(".Product__Info form.ProductForm .ProductForm__AddToCart").html(),
    );
    $(".sticky-product-wrapper .s-price").html(
      $(".Product__Info .ProductMeta__Price").html(),
    );
  }, 500);
});
$(document).on(
  "click",
  ".sticky-product-wrapper .s-ProductForm__AddToCart",
  function () {
    $(".Product__Info form.ProductForm .ProductForm__AddToCart").trigger(
      "click",
    );
  },
);
$(document).on("click", ".sticky-right .QuantitySelector__Button", function () {
  let action = $(this).data("action");
  if (action == "decrease-quantity") {
    let val = parseInt($(this).next("input").val());
    if (val > 1) {
      val = val - 1;
      $(".QuantitySelector__CurrentQuantity").val(val);
    }
  } else {
    let val = parseInt($(this).prev("input").val());
    val = val + 1;
    $(".QuantitySelector__CurrentQuantity").val(val);
  }
});
$(window).on("load scroll", function () {
  if ($(".Product__Info form.ProductForm .ProductForm__AddToCart").length > 0) {
    if (
      $(this).scrollTop() >
      $(".Product__Info form.ProductForm .ProductForm__AddToCart").offset()
        .top -
        100
    ) {
      $("#sticky-product-container").addClass("active");
    } else {
      $("#sticky-product-container").removeClass("active");
    }
  }
});

/*
  The slideshow runs with Flickity's setGallerySize and adaptiveHeight both
  false (see sections/slideshow.liquid), so nothing sizes the carousel and the
  height has to be set here.

  The previous version added the selected slide's height to a .SectionHeader
  height, but there are four .SectionHeader elements in the slideshow (a mobile
  and a desktop copy per slide) and jQuery returns the first, which is not the
  visible one. It also double counted, because the header sits inside the
  slide. Measured on a real page that came out roughly 16px short, which is why
  content spilled into the next section.

  scrollHeight reports the slide's true content height even though CSS clips it
  to 325px, so one measurement replaces the sum and the guesswork.
*/
function resizeSliderHeight() {
  var $wrap = $("#shopify-section-slideshow .Slideshow__mobile");
  if (!$wrap.length) return;

  if ($(window).width() < 641) {
    var slide = document.querySelector(
      "#shopify-section-slideshow .Slideshow__Slide.is-selected",
    );
    if (!slide) return;

    /*
      Flickity renders .flickity-page-dots as a sibling of .flickity-viewport,
      so they sit outside the slide. Measuring the slide alone leaves the dots
      hanging past the bottom edge and over the next section. Add their height
      and margins so the wrapper covers everything it contains.
    */
    var dots = document.querySelector(
      "#shopify-section-slideshow .flickity-page-dots",
    );
    var dotsHeight = 0;
    if (dots) {
      var dotStyles = window.getComputedStyle(dots);
      dotsHeight =
        dots.offsetHeight +
        parseFloat(dotStyles.marginTop || 0) +
        parseFloat(dotStyles.marginBottom || 0);
    }

    $wrap.css("height", slide.scrollHeight + dotsHeight + "px");
  } else {
    $wrap.removeAttr("style");
  }
}
var x;
$(window).on("load", function () {
  add_extra_link();
});

function add_extra_link() {
  setTimeout(function () {
    if ($(".agree-to-terms-wrapper").length > 0) {
      $(".agree-to-terms-wrapper input[type='checkbox']").prop("checked", true); //.css({"opacity":"0", "position":"absolute", "z-index": "-999"});
      $(".agree-to-terms-wrapper .text-wrapper").append(
        ' & <a class="td-link" target="_blank" href="https://hempz-com.myshopify.com/pages/privacy-policy"> Privacy Policy.</a>',
      );
    } else {
      add_extra_link();
    }
  }, 600);
}

$("body").on("click", ".additionDetails .cf-accordion-title", function () {
  $(this).stop().toggleClass("active");
  $(this).next(".inner").stop().slideToggle();
});

$(document).on("click", ".gw-ig-post-card__backdrop", function () {
  setTimeout(function () {
    if ($(".gw-ig-post-modal-tags-list").length > 0) {
      $(
        `<div class="dynamic-insta-text">${custom_values.instagram_text}</div>`,
      ).insertAfter(".gw-ig-post-modal-tags-list");
    }
  }, 1500);
});

var instaSlickCurrent = 0;
$(function () {
  if ($("body").hasClass("template-index")) {
    if ($(window).width() < 600) {
      let init_instaSlide = setInterval(function () {
        if (
          $(".customHtml .gw-slider-arrows").length > 0 ||
          $(".customHtml .slick-slide").length == 0
        ) {
          $(".customHtml .gw-slider-arrows").remove();
          $(
            ".customHtml .gw-slider__slides, .customHtml .gw-slider__slides *",
          ).removeAttr("style");
          $(".customHtml .gw-slider__slides >div")
            .not(".slick-initialized")
            .slick({
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
              initialSlide: instaSlickCurrent,
            });
          $(".customHtml .gw-slider__slides >div").on(
            "afterChange",
            function (event, slick, currentSlide, nextSlide) {
              instaSlickCurrent = currentSlide;
            },
          );
        }
      }, 200);
    }
  }
});

/****** shogun form validation *********/
var $form = $(".offer-signup_kla_form form.shogun-form-box");
$(".offer-signup_kla_form button[type='submit'].shogun-form-box-submit").on(
  "click",
  function () {
    var toReturn = true;
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    $("input[type='text'], select", $form).each(function () {
      if ($(this).val() == "") {
        $(this).next().addClass("err_msgs");
        toReturn = false;
      } else {
        $(this).next().removeClass("err_msgs");
        return (toReturn = true);
      }
    });

    $("input[type='email']", $form).each(function () {
      if ($(this).val().match(validRegex)) {
        $(this).next().removeClass("err_msgs");
        return (toReturn = true);
      } else {
        $(this).next().addClass("err_msgs");
        toReturn = false;
      }
    });

    $("input[type='checkbox']", $form).each(function () {
      if ($(this).is(":checked")) {
        $(this)
          .parent(".shogun-form-checkbox-input-wrapper")
          .next()
          .removeClass("err_msgs");
        return (toReturn = true);
      } else {
        $(this)
          .parent(".shogun-form-checkbox-input-wrapper")
          .next()
          .addClass("err_msgs");
        toReturn = false;
      }
    });

    return (toReturn = true);
  },
);

$(document).ready(function () {
  //$('.Article__Body h2').wrap('<div class="h2-heading"></div>');
  //$('.Article__Body ul').wrap('<div class="list-block"></div>');
  /*$('.Article__Body p').each(function() {
        if ($(this).find('img').length > 0) {
          $(this).wrap('<div class="sideimage"></div>');
        }
  });
  setTimeout(function () {
    var $articleBody = $('.Article__Body');
    $articleBody.wrapInner('<div class="newWrapper"></div>');
  }, 2000);*/
  if ($("body").hasClass("new-article")) {
    var tableRows = $(".Article__Body table tbody tr");
    tableRows.each(function (index) {
      var td1 = $(this).find("td:eq(0)").html();
      var td2 = $(this).find("td:eq(1)").html();

      var uniqueId = "div" + index;

      var divStructure =
        '<div id="' +
        uniqueId +
        '" class="parentDiv"><div class="left">' +
        td1 +
        '</div><div class="right">' +
        td2 +
        "</div></div>";

      $("#parentDivs").append(divStructure);
    });
  }

  if ($("#shopify-section-beauty-actives-featured-collections").length != 0) {
    if ($("body").hasClass("new-article")) {
      let $featuredCollections = $(
        "#shopify-section-beauty-actives-featured-collections",
      );
      let $articleBanner = $(".article-banner");
      if ($featuredCollections.length > 0 && $articleBanner.length > 0) {
        $featuredCollections.insertAfter($articleBanner);
      }
    }
  }
  if ($("#shopify-section-hair-featured-collections").length != 0) {
    if ($("body").hasClass("new-article")) {
      let $featuredCollections = $(
        "#shopify-section-hair-featured-collections",
      );
      let $articleBanner = $(".article-banner");
      if ($featuredCollections.length > 0 && $articleBanner.length > 0) {
        $featuredCollections.insertAfter($articleBanner);
      }
    }
  }

  $(".Article__Body p").each(function () {
    var $pElement = $(this);
    var $image = $pElement.find("img");
    if ($image.length > 0) {
      var $sideimage = $('<div class="sideimage"></div>');
      $image.appendTo($sideimage);
      $pElement.replaceWith($sideimage);
    }
  });

  if ($("#Slider_relatedArticles .article-box").length > 3) {
    $("#Slider_relatedArticles").slick({
      autoplay: false,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 800,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if ($(".new-survey-container").length > 0) {
    console.log("survey found");
    let count = 0;
    let findInterval = setInterval(function () {
      $(".new-survey-container form [data-testid='form-row']").each(
        function () {
          if ($(this).find("img").length > 0) {
            $(this).addClass("option-image-block");
            count++;
          }
          if ($(this).find("input[type='text']").length > 0) {
            $(this).find("input[type='text']").attr("maxlength", "250");
            $(this)
              .find("input[type='text']")
              .parent()
              .addClass("set-max-length")
              .attr("data-count", "0/250");
            count++;
          }
          if (count > 1) {
            clearInterval(findInterval);
          }
        },
      );
      console.log("done");
    }, 500);
    $(document).on(
      "keyup",
      ".new-survey-container form input[type='text']",
      function () {
        $(".new-survey-container form .set-max-length").attr(
          "data-count",
          $(this).val().length + "/250",
        );
        if ($(this).val().length == 250) {
          $(".new-survey-container form input[type='text']")
            .parent()
            .addClass("show-maxlen-msg");
          setTimeout(function () {
            $(".new-survey-container form input[type='text']")
              .parent()
              .removeClass("show-maxlen-msg");
          }, 5000);
        }
      },
    );
  }

  /* hulk form custom codes */
  /* Core survey */
  if ($("#nt7XsX3CJltG1mWPzOYgLQ").length > 0) {
    console.log("Core survey form found");
    let coreInterval = setInterval(function () {
      if ($(".formElement_0").length > 0) {
        $(".formElement_0").append(`<div class="option-images">
          <img src="https://cdn.shopify.com/s/files/1/0259/5481/1990/files/core-option1.jpg?v=1762521333">
          <img src="https://cdn.shopify.com/s/files/1/0259/5481/1990/files/core-option2.jpg?v=1762521375"></div>`);
        $("#nt7XsX3CJltG1mWPzOYgLQ form").append(
          `<p>By submitting this form, you consent to receive informational (e.g., order updates) and/or marketing texts (e.g., cart reminders) from HEMPZ. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Unsubscribe at any time by clicking the unsubscribe link (where available).&nbsp;<a href="https://hempz.com/pages/privacy-policy" target="_blank">Privacy Policy</a> &amp; <a href="https://hempz.com/pages/terms-conditions" target="_blank">Terms of Service</a>.</p>`,
        );
        clearInterval(coreInterval);
        if (
          $(".pxFormGenerator .formElement_3").find("input[type='text']")
            .length > 0
        ) {
          $(".pxFormGenerator .formElement_3")
            .find("input[type='text']")
            .attr("maxlength", "250");
          $(".pxFormGenerator .formElement_3")
            .addClass("set-max-length")
            .attr("data-count", "0/250");
        }
      }
    }, 500);

    let submitInterval = setInterval(function () {
      if ($(".after_form_submit input").length > 0) {
        window.location.href = "/pages/thank-you";
        clearInterval(submitInterval);
      }
    }, 1000);
  }

  /* Fashion survey */
  if ($("#m5BeSCQgWnrPYnOoQnV2DA").length > 0) {
    console.log("Core survey form found");
    let coreInterval = setInterval(function () {
      if ($(".formElement_0").length > 0) {
        $(".formElement_0").append(`<div class="option-images">
          <img src="https://cdn.shopify.com/s/files/1/0259/5481/1990/files/fashion-option1.jpg?v=1762531540">
          <img src="https://cdn.shopify.com/s/files/1/0259/5481/1990/files/fashion-option2.jpg?v=1762531540"></div>`);
        $("#m5BeSCQgWnrPYnOoQnV2DA form").append(
          `<p>By submitting this form, you consent to receive informational (e.g., order updates) and/or marketing texts (e.g., cart reminders) from HEMPZ. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Unsubscribe at any time by clicking the unsubscribe link (where available).&nbsp;<a href="https://hempz.com/pages/privacy-policy" target="_blank">Privacy Policy</a> &amp; <a href="https://hempz.com/pages/terms-conditions" target="_blank">Terms of Service</a>.</p>`,
        );
        clearInterval(coreInterval);
        if (
          $(".pxFormGenerator .formElement_3").find("input[type='text']")
            .length > 0
        ) {
          $(".pxFormGenerator .formElement_3")
            .find("input[type='text']")
            .attr("maxlength", "250");
          $(".pxFormGenerator .formElement_3")
            .addClass("set-max-length")
            .attr("data-count", "0/250");
        }
      }
    }, 500);

    let submitInterval = setInterval(function () {
      if ($(".after_form_submit input").length > 0) {
        window.location.href = "/pages/thank-you-fashion-survey";
        clearInterval(submitInterval);
      }
    }, 1000);
  }

  /* Beauty actives survey */
  if ($("#QTNxafVqT5g-qWl-7LNliw").length > 0) {
    console.log("Core survey form found");
    let coreInterval = setInterval(function () {
      if ($(".formElement_0").length > 0) {
        $(".formElement_0").append(`<div class="option-images">
          <img src="https://cdn.shopify.com/s/files/1/0259/5481/1990/files/fashion-option1.jpg?v=1762531540">
          <img src="https://cdn.shopify.com/s/files/1/0259/5481/1990/files/fashion-option2.jpg?v=1762531540"></div>`);
        $("#QTNxafVqT5g-qWl-7LNliw form").append(
          `<p>By submitting this form, you consent to receive informational (e.g., order updates) and/or marketing texts (e.g., cart reminders) from HEMPZ. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Unsubscribe at any time by clicking the unsubscribe link (where available).&nbsp;<a href="https://hempz.com/pages/privacy-policy" target="_blank">Privacy Policy</a> &amp; <a href="https://hempz.com/pages/terms-conditions" target="_blank">Terms of Service</a>.</p>`,
        );
        clearInterval(coreInterval);
        if (
          $(".pxFormGenerator .formElement_3").find("input[type='text']")
            .length > 0
        ) {
          $(".pxFormGenerator .formElement_3")
            .find("input[type='text']")
            .attr("maxlength", "250");
          $(".pxFormGenerator .formElement_3")
            .addClass("set-max-length")
            .attr("data-count", "0/250");
        }
      }
    }, 500);

    let submitInterval = setInterval(function () {
      if ($(".after_form_submit input").length > 0) {
        window.location.href = "/pages/thank-you-beauty-actives-survey";
        clearInterval(submitInterval);
      }
    }, 1000);
  }

  $(document).on(
    "keyup",
    ".pxFormGenerator .formElement_3 input[type='text']",
    function () {
      $(".pxFormGenerator .set-max-length").attr(
        "data-count",
        $(this).val().length + "/250",
      );
      if ($(this).val().length == 250) {
        $(".pxFormGenerator .formElement_3")
          .parent()
          .addClass("show-maxlen-msg");
        setTimeout(function () {
          $(".pxFormGenerator .formElement_3")
            .parent()
            .removeClass("show-maxlen-msg");
        }, 5000);
      }
    },
  );
});

$(window).on("load", function () {
  $(document).on("click", ".stamped-badge-overlay", function () {
    $("html, body").animate(
      {
        scrollTop: $("#stamped-main-widget").offset().top,
      },
      300,
    );

    $("html, body").animate(
      {
        scrollTop: $("#stamped-main-widget").offset().top,
      },
      1000,
    );

    /*if (isTriggered) return;
    setTimeout(function () {
      
      $(".stamped-badge-overlay").trigger("click");
      isTriggered = true;
    }, 1000);*/
  });
});
